import React from "react";
import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft, Headphones, MessageSquare } from "lucide-react";
import Navbar from "../../components/layout/Navbar/Navbar";
import Footer from "../../components/layout/Footer/Footer";
import "./NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <Navbar />
      <div className="not-found-container">
        <div className="not-found-blobs">
          <div className="blob blob-1"></div>
          <div className="blob blob-2"></div>
        </div>

        <div className="not-found-content">
          <div className="not-found-hero">
            <div className="not-found-number">
              <span className="digit">4</span>
              <div className="circle-animation"></div>
              <span className="digit">4</span>
            </div>
            <h1 className="not-found-title">Page Not Found</h1>
            <p className="not-found-subtitle">
              Oops! The page you're looking for seems to have wandered off. 
              Don't worry, we'll help you get back on track.
            </p>
          </div>

          <div className="not-found-actions">
            <button 
              className="action-btn primary-btn"
              onClick={() => navigate("/")}
            >
              <Home size={18} />
              Back to Home
            </button>
            <button 
              className="action-btn secondary-btn"
              onClick={() => navigate(-1)}
            >
              <ArrowLeft size={18} />
              Go Back
            </button>
          </div>

          <div className="not-found-links">
            <h2>What can we help you with?</h2>
            <div className="links-grid">
              <a href="/blog" className="link-card">
                <div className="link-icon">📚</div>
                <h3>Read Our Blog</h3>
                <p>Explore articles and tips from our community</p>
              </a>
              <a href="/about" className="link-card">
                <div className="link-icon">ℹ️</div>
                <h3>About Squaay</h3>
                <p>Learn more about our platform and mission</p>
              </a>
              <a href="/help-center" className="link-card">
                <div className="link-icon">💬</div>
                <h3>Contact Support</h3>
                <p>Get help from our friendly support team</p>
              </a>
            </div>
          </div>

          <div className="not-found-support">
            <div className="support-card">
              <div className="support-header">
                <Headphones size={24} />
                <h3>Need Assistance?</h3>
              </div>
              <p>Our support team is ready to help you 24/7</p>
              <div className="support-contacts">
                <a href="mailto:support@squaay.com" className="contact-link">
                  <MessageSquare size={16} />
                  support@squaay.com
                </a>
                <a href="tel:+2348084082347" className="contact-link">
                  📞 +234 (808) 408-2347
                </a>
              </div>
            </div>
          </div>

          <div className="floating-icons">
            <div className="icon-float">🍕</div>
            <div className="icon-float">🏍️</div>
            <div className="icon-float">🎯</div>
            <div className="icon-float">⚡</div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
